import { ChangeDetectionStrategy, Component, Input, ViewChild } from '@angular/core';
import { MenuItem } from './menu-item';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'ndt-nested-menu',
    templateUrl: './nested-menu.component.html',
    standalone: false
})
export class NestedMenuComponent {
   @Input() items: MenuItem[];

   @ViewChild('childMenu', { static: true }) public childMenu: any;
}
